
var $body,
    $toggleMenu;


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body = $('body');
    $toggleMenu = $("#toggleMenu");+
    
    changeUploadFields();

    $toggleMenu.click(function(){
        $body.toggleClass('show-menu');
    })

});


function changeUploadFields() {
  $('.ginput_container_fileupload').each(function () {
      const currentHtml = $(this).html();
      const newHtml = '<label class="file-upload"><i class="fal fa-upload"></i> <span class="file-upload__inner js-upload-text">Upload je bestand</span>' + currentHtml + '</label>'
      $(this).html(newHtml);
      const currentInput = $(this).find('input[type="file"]');
      currentInput.change(function () {
          $(this).parent().find('.js-upload-text').text(this.files[0].name);
      });
  });
}
